module.exports = __webpack_public_path__ + "static/media/ajax-loader.f3233732.gif";


//////////////////
// WEBPACK FOOTER
// ./public/images/ajax-loader.gif
// module id = 1547
// module chunks = 1